import { render, staticRenderFns } from "./Erro.vue?vue&type=template&id=5f9b9e03&scoped=true"
import script from "./Erro.vue?vue&type=script&lang=js"
export * from "./Erro.vue?vue&type=script&lang=js"
import style0 from "./Erro.vue?vue&type=style&index=0&id=5f9b9e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b9e03",
  null
  
)

export default component.exports